import { render, staticRenderFns } from "./ApaItuMobile.vue?vue&type=template&id=dcaa8704&scoped=true&"
import script from "./ApaItuMobile.vue?vue&type=script&lang=js&"
export * from "./ApaItuMobile.vue?vue&type=script&lang=js&"
import style0 from "./ApaItuMobile.vue?vue&type=style&index=0&id=dcaa8704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcaa8704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VLayout,VSkeletonLoader})
